<template>
  <div class="container d-flex flex-column justify-content-center">
    <div class="d-flex riga">
      <div class="col-md-12 col-lg-12 d-flex is-flex-direction-column is-justify-content-center is-align-items-center">
        <h1>{{ trans.get('public.footer.subscribe') }}</h1>
        <p>{{ trans.get('public.footer.keep-up') }}</p>
        <ValidationObserver v-slot="{ invalid }">
          <div id="newsletter-form" class="row" >
            <div class="col-md-6 col-12 form-group">
              <ValidationProvider class="d-flex is-flex-direction-column is-align-items-center" rules="required"
                                  v-slot="{ errors }">
                <input
                    type="text"
                    class="form-control"
                    :class="errors[0] ? 'invalid' : ''"
                    id="fname"
                    v-model="fname"
                    :name="fname"
                    :placeholder="$trans('public.footer.fname')"
                />
                <small>{{ errors[0] }}</small>
              </ValidationProvider>
            </div>
            <div class="col-md-6 col-12 form-group">
              <ValidationProvider class="d-flex is-flex-direction-column is-align-items-center" rules="required"
                                  v-slot="{ errors }">
                <input
                    type="text"
                    class="form-control"
                    :class="errors[0] ? 'invalid' : ''"
                    id="lname"
                    v-model="lname"
                    :name="lname"

                    :placeholder="$trans('public.footer.lname')"
                />
                <small>{{ errors[0] }}</small>
              </ValidationProvider>
              </div>
              <div class="col-md-9 col-12 form-group">
              <ValidationProvider class="d-flex is-flex-direction-column is-align-items-center" rules="email|required"
                                  v-slot="{ errors }">
                <input
                    type="email"
                    class="form-control"
                    :class="errors[0] ? 'invalid' : ''"
                    id="email"
                    v-model="email"
                    :name="email"

                    :placeholder="$trans('public.footer.email')"
                />
                <small>{{ errors[0] }}</small>
              </ValidationProvider>
                </div>
                <div class="col-md-3 col-12 form-group">
              <button
                  type="submit"
                  class="mt-25px btn-my-primary"
                  :disabled="invalid"
                  @click="regNewsletter"
              >
                {{ trans.get("b2b.footer.send") }}
              </button>
                </div>
            </div>

        </ValidationObserver>
      </div>
      <div class="col-md-12 social">
        <ul>
          <li><a href="https://www.linkedin.com/company/4-belt/" target="_blank"><i class="fab fa-linkedin-in"></i></a>
          </li>
          <li><a href="https://www.instagram.com/4belt_italy/" target="_blank"><i class="fab fa-instagram"></i></a></li>
          <li><a href="https://www.facebook.com/thermoweldable/" target="_blank"><i class="fab fa-facebook-f"></i></a>
          </li>
        </ul>
      </div>
      <div class="col-md-12 col-lg-12 d-flex justify-content-center align-items-center">
        <div class="d-flex is-flex-direction-column is-align-items-center is-justify-content-center h-100">
          <p>
            4-Belt srl | Via Cacace, 8 - 30030 Maerne di Martellago - Venice (ITALY) | Telephone <a href="tel:+390415030759">+39 041 50 30 759</a> |
            Fax +39 041 641 799
          </p>
          <p>Email: info@4-belt.com | P.iva 04265710279</p>
          <p>Developed by <a href="https://ululab.it">Ululab</a></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ValidationObserver} from "vee-validate";
import {ValidationProvider} from "vee-validate";

export default {
  name: "form-newsletter-new",
  components: {
    ValidationObserver,
    ValidationProvider,
  },

  data() {
    return {
      email: null,
      fname: null,
      lname: null,
      html_form: null,
    };
  },
  mounted() {
  },
  methods: {
    alertCustomError(msg, type = 'success',) {
      this.$buefy.dialog.alert({
        title: (type === 'error') ? 'Errore' : 'Iscrizione newsletter',
        message: msg,
        type: (type === 'error') ? 'is-danger' : 'is-success',
        hasIcon: true,
        icon: (type === 'error') ? 'times-circle' : 'check-circle',
        iconPack: 'fa',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    regNewsletter: function () {
      const loadingComponent = this.$buefy.loading.open({
        container: null,
      })
      this.html_form = document.getElementById('newsletter-form').outerHTML

      axios({
        method: 'post',
        url: window.location.origin + '/data/newsletter',
        data: {
          fname: this.fname,
          lname: this.lname,
          email: this.email,
          html_form: this.html_form,
        }
      }).then(res => {
        console.log(res.data.message)
        this.alertCustomError(res.data.message)
        loadingComponent.close()
        this.fname = null
        this.email = null
        this.lname = null
        this.html_form = null
      }).catch(err => {
        this.alertCustomError(err.response.data.message, 'error',)
        loadingComponent.close()
      })
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  text-decoration: underline;
}
.container {
  background-color: #0e0e0e;
  font-size: 1em;
  @media (min-width: 1921px){
    font-size: var(--font-size-large);
  }
  padding-top: 0!important;
  h1 {
    font-size: 32px;
  }
  label {
    text-align: center;

  }

  .riga {
    padding: 0;
    flex-wrap: wrap;
    h1 {
      margin: 25px 0;
    }
    p {
      margin: 15px 0;
      text-align: center;
    }
  ;

    .social {
      margin-top: 10px;

      ul {
        width: 100%;
        display: flex;
        justify-content: center;

        li i {
          font-size: 30px;
          margin: 0 15px;

          &:hover {
            color: var(--greenb2b);
          }
        }
      }
    }
    #newsletter-form {
      margin-top: 10px;
    }
    #fname {
      margin-right: 15px;
      @media (max-width: 576px) {
        margin-right: 0;
        margin-bottom: 18px;
      }
    }
    #lname {
      @media (max-width: 576px) {
        margin-bottom: 18px;
      }
    }
    #email {
      margin-top: 20px;
      margin-right: 15px;
      @media (max-width: 576px) {
        margin-right: 0;
        margin-top: 0;
        margin-bottom: 18px;
      }
    }
    .form-group {
      display: flex;
      margin-bottom: 0;
      padding: 0;
      position: relative;
      span {
        display: inline-block;
        width: 100%;
      }
      label {
        margin-left: 60px;
      }

      button {
        height: 38px;
        align-self: flex-end;
        width: 100%;
        @media (max-width: 576px) {
          align-self: center;
          margin: 5px 0 0;
        }
      }

      @media (max-width: 576px) {
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }
  }

  color: #fff;


  ul {
    list-style: none;

    li {
      margin: 1rem 0;
    }
  }

  form {
    margin-top: 1rem;
  }

  button[disabled="disabled"] {
    background-color: #25252a;
    color: #4d4d50;
    border-color: transparent;
  }

  input,
  textarea {
    border-radius: 0;
    background-color: inherit;
    color: #fff;

    &::placeholder {
      color: #fff;
      font-weight: 400;
    }

    &:focus {
      border-color: var(--greenb2b);
      box-shadow: 0 0 0 0.2rem rgba(166, 249, 52, 0.25);
    }

    &.invalid {
      border-color: var(--red);
      box-shadow: 0 0 0 0.2rem rgba(255, 35, 61, 0.25);
    }
  }

  input {
    width: 100%;
    text-align: center;
  }

  small {
    position: absolute;
    bottom: -18px;
    color: var(--red);
    @media (max-width: 576px) {
      bottom: -3px;
    }

    &.file-error {
      margin-left: -30px;
      margin-right: 20px;
    }
  }

  .invia {
    display: inline-block;
    width: 100px;
    height: 40px;
    color: #000;
    font-size: 14px;
    background-color: #fff;
    margin: 0.8rem 0;

    &:hover {
      box-shadow: 1px 1px 1px var(--greenb2b);
    }

  }
}
@media (min-width: 1921px) {

//  .container .riga h4 {
//    font-size: 30px;
//  }
//  .container .riga p, .container p {
//    font-size: 26px;
//  }
//.form-control {
//  font-size: 26px;
//
//}
//  .container .riga .form-group button {
//    height: 53px;
//  }
//  .container .invia {
//    font-size: 26px;
//  }
//  .container .riga .social ul li i {
//    font-size: 40px;
//  }
}
</style>
